<div
  style="
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 100vh;
    width: 99vw;
    justify-content: flex-start;
    align-items: stretch;
    flex-wrap: nowrap;
  "
>
  <div style="order: 1; flex: 20">
    <app-header></app-header>
  </div>
  <div style="order: 2; flex: 80">
    <router-outlet></router-outlet>
  </div>
  <div style="order: 3; flex: 0">
    <app-footer> </app-footer>
  </div>
</div>
